<template>
  <div id="UAV_auto">
    <div class="font">
      <span class="introSubTitle"><b>通导遥一体的无人机远程全自主感知系统</b></span>
      <p class="textStyle">研制远程无人机集群全自动快速感知系统，基于北斗报文或无线自组网通信，一键远程启动多机观测，快速回传任务信息；采用光伏发电+电池储能备份系统实现能源提供，研制专用多机数据处理系统，实现多机全自动快速影像校正、拼接、变化检测、异常信息提取，实现任务现场在线自动感兴趣范围快速提取。</p>
    </div>
   <!-- <br/>   -->
    <div style="text-align: center">       <!--    居中开始    -->
    <img width="80%" src="@/assets/img/scientific/UAV_auto1.png" />
    <!--    <p class="img_figure">轻小型无人机机巢</p>     -->
    <img width="100%" src="@/assets/img/scientific/UAV_auto2.png" />
  </div>                 <!--    居中结束    -->
<!--    <p class="img_figure">航线规划</p>    -->
    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {src: require("@/assets/static/Quick_change.mp4"), type:"video/mp4"},
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#UAV_auto {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
